import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthenticatedGuard } from '../../../guards/authenticated.guard';
import { HomePageComponent } from './home.page';

const routes: Routes = [
  {
    canActivate: [AuthenticatedGuard],
    component: HomePageComponent,
    path: ''
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class HomePageRoutingModule {}
